import { datadogRum } from "@datadog/browser-rum";
import { Box } from "@mui/material";
import { grayBackground } from "@notemeal/palette";
import { capitalize } from "@notemeal/shared/ui/utils/capitalize";
import { addDays, format } from "date-fns";
import React from "react";
import { UseFieldArrayReturn, UseFormReturn } from "react-hook-form";
import { useMenuBuilderContext } from "../MenuBuilderProvider";
import { MenuBuilderMealGridRow } from "./MenuBuilderMealGridRow";
import { MenuBuilderType } from "./MenuBuilderMealSchema";
import { BORDER_COLOR, DAY_CELL_WIDTH, LEFT_PANEL_CELL_WIDTH } from "./constants";

interface MenuBuilderMealProps {
  rows: UseFieldArrayReturn<MenuBuilderType>;
  form: UseFormReturn<MenuBuilderType>;
  weekFormIndex: number;
  mealFormIndex: number;
}

export const MenuBuilderMealGrid = ({ rows, form, mealFormIndex, weekFormIndex }: MenuBuilderMealProps) => {
  const { days, weeks, selectedWeekIndex, setRowsToDelete, rowsToDelete, menuId } = useMenuBuilderContext();

  const startDate = weeks[selectedWeekIndex].startDate;

  const deleteRow = (rowFormIndex: number) => {
    datadogRum.addAction("menu_builder.removed_dining_station", { menuId });
    // only delete rows that previously existed
    const rowId = form.getValues(`weeks.${weekFormIndex}.meals.${mealFormIndex}.rows.${rowFormIndex}`).id;
    if (rowId) {
      setRowsToDelete([...rowsToDelete, rowId]);
    }
    rows.remove(rowFormIndex);
  };

  return (
    <Box>
      {/* header with days */}
      <Box sx={{ display: "grid" }}>
        <Box
          sx={{
            backgroundColor: grayBackground,
            minWidth: LEFT_PANEL_CELL_WIDTH,
            height: "50px",
            borderWidth: "0px 1px 1px 1px",
            borderStyle: "solid",
            borderColor: BORDER_COLOR,
          }}
        ></Box>
        {days.map((day, index) => (
          <Box
            key={day}
            sx={{
              backgroundColor: theme => theme.palette.background.default,
              borderWidth: "0px 1px 1px 0px",
              borderStyle: "solid",
              borderColor: BORDER_COLOR,
              gridColumn: `${index + 2}`,
              width: DAY_CELL_WIDTH,
              height: "50px",
              justifyContent: "center",
              alignContent: "center",
              display: "grid",
            }}
          >
            <Box>
              <Box display={"inline"}>{capitalize(day)}</Box>{" "}
              <Box display={"inline"} sx={{ fontWeight: 600 }}>
                {format(addDays(startDate, index), "d")}
              </Box>
            </Box>
          </Box>
        ))}
      </Box>

      {/* cells for rows with menu items */}

      {rows.fields.map((row, index) => (
        <MenuBuilderMealGridRow
          key={row.id}
          form={form}
          weekFormIndex={weekFormIndex}
          mealFormIndex={mealFormIndex}
          rowFormIndex={index}
          deleteRow={deleteRow}
        />
      ))}
    </Box>
  );
};
